export default __webpack_public_path__ + "static/ronan-mccabe-2d99b1c00c140aeabe86d8ca5023d42e.png";